import { module } from 'modujs';
import { gsap } from 'gsap';
import { CustomEase } from "gsap/CustomEase";
import { html } from '../utils/environment';

gsap.registerPlugin(CustomEase);

const EASE = CustomEase.create("custom", "M0,0,C0.081,0,0.104,0.001,0.176,0.076,0.28,0.183,0.428,0.389,0.507,0.512,0.575,0.619,0.721,0.808,0.8,0.9,0.874,0.986,0.906,1,1,1")

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if(!html.classList.contains('has-scroll-smooth')) return;

        this.title = Array.from(this.$('title')[0].children).map(el => el.innerText)
        this.$link = this.$('link')[0]
        this.href = this.$link.getAttribute('href')
        // console.log(this.title);
        this.$visual = this.$('visual')[0]

        const tweenObj = { scaleX: 1 };

        this.timeline = gsap.timeline({
            onUpdate: () => {
                gsap.set(this.el, { scaleX: tweenObj.scaleX, force3D: true })
                gsap.set(this.$visual, { scaleX: 1 / tweenObj.scaleX, force3D: true })

                const progress = this.timeline.progress()

                if(progress > 0.383 && progress < 0.616) {
                    this.call('setContent', { title: this.title, href: this.href }, 'ProjectListTitle')
                }
            }
        });

        this.timeline.to(tweenObj, { duration: 0.333, scaleX: 0.5, ease: EASE }, 0.167);

        // No end of timeline if last element
        const parentEl = this.el.parentElement
        if(Array.from(parentEl.children).indexOf(this.el) != parentEl.children.length-1)
            this.timeline.to(tweenObj, { duration: 0.333, scaleX: 1 , ease: EASE});

        this.timeline.add(() => {}, 1);

        this.timeline.pause();
    }

    update(e) {
        if(e.el != this.el) return
        // console.log(e);
        if(this.timeline && this.timeline.progress) this.timeline.progress(e.progress)
    }

    destroy() {
        if(this.timeline && this.timeline.kill) {
            this.timeline.kill();
            this.timeline = null
            delete this.timeline;
        }
    }
}
